/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckSquareIcon32Regular = forwardRef('CheckSquareIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M23.058 12.487a1 1 0 0 0-1.414-1.415L14.617 18.1a1 1 0 0 1-1.414 0l-2.847-2.847a1 1 0 0 0-1.414 1.414l2.847 2.847a3 3 0 0 0 4.243 0l7.026-7.026Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 3A5.5 5.5 0 0 0 3 8.5v15A5.5 5.5 0 0 0 8.5 29h15a5.5 5.5 0 0 0 5.5-5.5v-15A5.5 5.5 0 0 0 23.5 3h-15ZM5 8.5A3.5 3.5 0 0 1 8.5 5h15A3.5 3.5 0 0 1 27 8.5v15a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 5 23.5v-15Z" })));
});
